import Modal from 'components/Modal/Modal.react';
import styles from 'components/Modal/Modal.scss';
import ParseApp from 'lib/ParseApp';
import PushCerts from 'components/PushAndroid/PushCerts.react';
import React from 'react';
import SashiDo from 'lib/SashiDo';

import PropTypes from 'prop-types';

export default class AndroidCerts extends React.Component {
  constructor() {
    super();

    this.state = {
      credentials: undefined,
      deletePending: null,
      deleteProgress: null,
      error: null,
    };

    this.handleKey = this.handleKey.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
  }

  componentDidMount() {
    document.body.addEventListener('keydown', this.handleKey);

    this.mounted = true;
    SashiDo.getAppSettings({ id: this.context.currentApp.id }).then((props) => {
      if (this.mounted) {
        this.setState({ credentials: props.gcm_credentials_v2 });
      }
    });
    // this.context.currentApp.getAppSettings().then((props) => {
    //   console.log('@@@ props', props);
    //   // if (this.mounted) {
    //   //   const certificates = certs.filter(f => f.type !== "push-apple-token");
    //   //   this.setState({ certificates });
    //   // }
    // });
  }

  componentWillUnmount() {
    document.body.removeEventListener('keydown', this.handleKey);
    this.mounted = false;
  }

  onCloseClick() {
    this.setState({ deletePending: null });
  }

  handleDelete(id) {
    this.setState({ deletePending: id, error: null });
  }

  handleKey(e) {
    const keyCode = e.keyCode || e.which;
    switch (keyCode) {
      case 27:
        this.onCloseClick(this);
        break;
    }
  }

  handleUpload = (props) => {
    const { file } = props;

    const reader = new FileReader();

    const currentAppId = this.context.currentApp.id;

    reader.onload = (event) => {
      try {
        const gcm_credentials_v2 = JSON.parse(event.target.result);

        SashiDo.setAndroidCredentials({
          id: currentAppId,
          gcm_credentials_v2,
        }).then((data) => {
          if (data) {
            Intercom('trackEvent', 'upload_android_credentials');
            // Wait a bit to let openshift catch up
            location.reload();
          }
        }).catch((error) => {
          this.setState({
            uploadPending: false,
            error: error.message,
          });
        });

        this.setState({ uploadPending: true, error: null });
        // Process your JSON object here
      } catch (e) {
        console.error("Error parsing JSON", e);
      }
    };

    reader.readAsText(file);
  }

  render() {
    const { credentials } = this.state;

    return (
      <div>
        <PushCerts
          credentials={credentials}
          error={this.state.error}
          uploadPending={this.state.uploadPending}
          onUpload={this.handleUpload}
          onDelete={this.handleDelete.bind(this)} />
        {this.state.deletePending === null ? null :
          <Modal
            type={Modal.Types.DANGER}
            title="Delete this JSON File"
            subtitle="Be careful, this action cannot be undone!"
            cancelText="Cancel"
            confirmText="Delete"
            progress={this.state.deleteProgress}
            onCancel={this.onCloseClick.bind(this)}
            onConfirm={() => {
              this.setState({ deleteProgress: true });
              const currentAppId = this.context.currentApp.id;
              SashiDo.setAndroidCredentials({
                id: currentAppId,
                gcm_credentials_v2: null,
              }).then((data) => {
                if (data) {
                  Intercom('trackEvent', 'delete_android_credentials');
                  // Wait a bit to let openshift catch up
                  this.setState({
                    deletePending: null,
                    deleteProgress: false,
                    credentials: null,
                  });
                }
              }).catch((error) => {
                this.setState({
                  uploadPending: false,
                  error: error.message,
                });
              });
            }}>
            <p className={styles.only}>Notifications will no longer be sent to <strong>{this.context.currentApp.slug}</strong>.</p>
          </Modal>
        }
      </div>
    );
  }
}

AndroidCerts.contextTypes = {
  currentApp: PropTypes.instanceOf(ParseApp),
};
